import { getExistingTriggerType } from 'automation-ui-enrollment/utils/EnrollmentDeciders';
import { StyledCriteraBorder } from 'automation-ui-enrollment/components/eventEnrollment/steps/EventEnrollmentReview';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'UIComponents/elements/headings';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import UIList from 'UIComponents/list/UIList';
import { getIsClassicWorkflow } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { useQuery } from 'data-fetching-client';
import { GET_SFDC_PORTAL_SETTINGS_QUERY, SFDC_KEY } from 'automation-ui-canvas/queries/SalesforceEnabledPortalSettingQuery';
import { useHistory } from 'react-router-dom';
import { getEnrollmentConfigRoute } from 'automation-ui-canvas/utils/absoluteRoutingUtils';
import UIButton from 'UIComponents/button/UIButton';
import EnrollmentCardContent from 'automation-ui-canvas/components/enrollment/EnrollmentCardContent';
import TriggerGroupDivider from 'automation-ui-enrollment/components/common/TriggerGroupDivider';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentReviewSection = ({
  flow
}) => {
  var _flow$classicEnrollme, _flow$classicEnrollme2;
  const {
    data: salesforcePortalSetting
  } = useQuery(GET_SFDC_PORTAL_SETTINGS_QUERY);
  const history = useHistory();
  const hasSfdcSetting = (salesforcePortalSetting === null || salesforcePortalSetting === void 0 ? void 0 : salesforcePortalSetting.portalSettings) && salesforcePortalSetting.portalSettings.settings.some(setting => setting.key === SFDC_KEY && setting.value === 'true');
  const triggerType = getExistingTriggerType(flow.toHybridFlowInterface());
  const enrollmentCritera = flow.enrollmentCriteria;
  let hasAutomaticTriggers = false;
  if (triggerType === 'EVENT' && (enrollmentCritera === null || enrollmentCritera === void 0 ? void 0 : enrollmentCritera.triggerType) === 'EVENT' && enrollmentCritera !== null && enrollmentCritera !== void 0 && enrollmentCritera.triggers) {
    hasAutomaticTriggers = true;
  } else if ((triggerType === 'LIST' || triggerType === 'SCHEDULE') && (enrollmentCritera === null || enrollmentCritera === void 0 ? void 0 : enrollmentCritera.triggerType) === 'LIST' && enrollmentCritera !== null && enrollmentCritera !== void 0 && enrollmentCritera.filterBranch) {
    hasAutomaticTriggers = true;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H7, {
      children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "platformReview.v2.enrollmentStep.enrollment.title_cob",
        objectTypeId: flow.objectTypeId
      })
    }), /*#__PURE__*/_jsx(StyledCriteraBorder, {
      padding: 12,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.enrollmentStep.enrollment.manual"
      })
    }), hasAutomaticTriggers && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(TriggerGroupDivider, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformReview.v2.enrollmentStep.enrollment.orTitle"
        })
      }), /*#__PURE__*/_jsx(StyledCriteraBorder, {
        children: /*#__PURE__*/_jsx(EnrollmentCardContent, {
          flow: flow,
          readOnly: true
        })
      })]
    }), getIsClassicWorkflow(flow) && /*#__PURE__*/_jsxs(UIList, {
      styled: true,
      className: "m-top-3 p-left-4 m-bottom-0",
      children: [/*#__PURE__*/_jsx("span", {
        children: (_flow$classicEnrollme = flow.classicEnrollmentSettings) !== null && _flow$classicEnrollme !== void 0 && _flow$classicEnrollme.allowEnrollmentFromMerge ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformReview.v2.enrollmentStep.enrollment.settings.merge.yesMerge"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformReview.v2.enrollmentStep.enrollment.settings.merge.noMerge"
        })
      }), hasSfdcSetting ? (_flow$classicEnrollme2 = flow.classicEnrollmentSettings) !== null && _flow$classicEnrollme2 !== void 0 && _flow$classicEnrollme2.canEnrollFromSalesforce ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.enrollmentStep.enrollment.settings.canEnrollFromSalesforce.yesEnroll"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.enrollmentStep.enrollment.settings.canEnrollFromSalesforce.noEnroll"
      }) : undefined]
    }), /*#__PURE__*/_jsx(UIButton, {
      className: "m-top-3",
      use: "tertiary-light",
      size: "small",
      onClick: () => {
        history.push({
          pathname: getEnrollmentConfigRoute({
            flow
          }),
          search: history.location.search
        });
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.enrollmentStep.enrollment.editEnrollment"
      })
    })]
  });
};
export default EnrollmentReviewSection;